import { Injectable } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UrlHelperService } from '../services/url-helper.service';
import { Session } from '../models/session.model';
import { AuthenticationService } from './authentication.serivce';
import { SecurityRole } from '../../shared/literals/shared.literal';
import { Router } from '@angular/router';

@Injectable()
export class PermissionReceiverService {

  public loaded = new Subject<boolean>();
  public isLoaded: boolean = false;
  private permissionSubscription: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient, private urlHelper: UrlHelperService, private router: Router) { }

  get(): void {
    var url: string = this.urlHelper.getApiUrl() + "AuthUser/GetPermissions";
    this.http.get<any>(url).pipe(takeUntil(this.permissionSubscription)).subscribe((perms: Array<any>) => {
      if (!perms) {

      } else {
        var session: Session | null = null;
        var json = localStorage.getItem('user_session');
        if (json) {
          session = JSON.parse(json.toString())
        }

        if (session) {
          session.permissions = perms;
          localStorage.setItem('user_session', JSON.stringify(session));
          this.isLoaded = true;
          this.loaded.next(true);

          this.permissionSubscription.next(true);
          this.permissionSubscription.unsubscribe();

          //If this user is an engineer, direct them to the bench template page
          if (session.securityRoleId == Number(SecurityRole.Engineer) || session.securityRoleId == Number(SecurityRole.EPCEngineer)) {

            var baseUrl = window.location.href.replace(this.router.url, '/BenchTemplate');
            window.location.replace(baseUrl);

          } else if (session.securityRoleId != Number(SecurityRole.Administrator)) { //Basically, 
          this.router.navigate(['/'])
            .then(() => {
              window.location.reload();
            });
          }
        }
      }
    })
  }

}
